import * as z from "zod";
import { ObjectiveStatus } from "@/types";
import { dueAfterStart, okrDateFields } from "./okr-date-schema";

export const objectiveSchema = z.object({
  name: z.string().min(3, "Name must be at least 3 characters").max(500),
  category: z.enum(["fintech", "ai", "company"], { required_error: "Pick a category" }),
  description: z.string().max(2000).optional().or(z.literal("")),
  context: z.string().max(10000, "Context must be at most 10000 characters").optional().or(z.literal("")),
  ...okrDateFields,
  ownerUserPid: z.string().optional().or(z.literal("")),
  status: z.nativeEnum(ObjectiveStatus).optional(),
}).superRefine(dueAfterStart);

export type ObjectiveFormValues = z.infer<typeof objectiveSchema>;
